/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
  console.log(position);

    $("html, body").animate({scrollTop:position}, speed, "swing");

    const $nav = $('.p-gnav');
    $nav.removeClass('is-show');

    return false;
  });
});

$(function(){
  // アンカー付きのURL、且つSPのみ
  var url = location.hash;
  var deviceWidth = window.innerWidth;

  if( url != "" && deviceWidth < 758 ) {
    $('body').append('<div class="loading-sp"></div>')
    $('html').imagesLoaded( function() {
      var target = $(url);
      var position = target.offset().top;
      $(window).scrollTop(position);
    });
  }

});

$(function(){
  $('.p-hd__menu a').each(function(index, el) {
    const $menu = $(this);
    const $nav = $('.p-gnav');
    const $close = $('.p-gnav__close');

    $menu.on('click', function(event) {
      runOpen();
    });

    $close.on('click', function(event) {
      runClose();
    });

    function runOpen() {
      $nav.addClass('is-show');
    }

    function runClose() {
      $nav.removeClass('is-show');
    }
  });
});


$(function(){
  $('.home-event__slick').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      centerMode: true,
      variableWidth: true,
      infinite: false
    });

    // if($(window).innerWidth() >= 768) {
    //   $slider.slick('slickGoTo', 1, true);
    // }
  });
});

$(function(){
  $('.home-kv').each(function(index, el) {
    const $kv = $(this);

    setTimeout(function(){
      $kv.addClass('is-ani');
    }, 400);
  });
});

$(function(){
  $('.home-kv__imgMask').each(function(index, el) {
    const $root = $(this);
    const $mask = $root.find('span');
    let numList = [];

    $mask.each(function(index, el) {
      numList[index] = index + 1;
    });

    numList = obj_array_shuffle(numList);

    $mask.each(function(index, el) {
      $(this).addClass('-rnd' + numList[index]);
    });
  });

  function obj_array_shuffle(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      if (i == j) continue;
      var k = list[i];
      list[i] = list[j];
      list[j] = k;
    }
    return list;
  }
});

//fade
$(function(){
  var fade = $('.fade, .fadeAni');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 0;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 0;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fade-next');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  $('.home-kv').each(function(index, el) {
    const $kv = $(this);
    const $header = $('.l-header');
    let isSc = false;

    $(window).on('scroll', function(event) {
      run();
    });

    run();

    function run() {
      if($(window).scrollTop() > $kv.innerHeight() - 2 ) {
        if(!isSc)  {
          isSc = true;

          $header.addClass('is-homeSc');
        }
      } else {
        if(isSc)  {
          isSc = false;

          $header.removeClass('is-homeSc');
        }
      }
    }
  });
});

$(function(){
  $('.history-con__more').each(function(index, el) {
    const $more = $(this);
    const $btn = $more.find('a');
    const $tar = $more.prev();

    $btn.on('click', function(event) {
      $btn.addClass('is-hide');
      let curHeight = $tar.height();
      $tar.addClass('is-open');
      let autoHeight = $tar.height();
      $tar.height(curHeight).animate({height: autoHeight}, 300);

      // テキストを開いたときの写真の位置を調整する
      const $block = $btn.closest('.history-con__block');
      const suffix = window.innerWidth < 840 ? '-sp' : '';
      const paddingBottom = $block.data('padding-bottom-if-open' + suffix);
      if (paddingBottom) {
        $block.animate({'padding-bottom': paddingBottom}, 300);
      }
      const marginBottom = $block.data('margin-bottom-if-open' + suffix);
      if (marginBottom) {
        $block.animate({'margin-bottom': marginBottom}, 300);
      }
    });
  });
});




var youtubeTag = document.createElement('script');
youtubeTag.src = "https://www.youtube.com/iframe_api";
var youtubeFirstScriptTag = document.getElementsByTagName('script')[0];
youtubeFirstScriptTag.parentNode.insertBefore(youtubeTag, youtubeFirstScriptTag);
var youtubePlayers = [];

function onYouTubeIframeAPIReady() {

  setTimeout(function(){
    $('.js-youtubePlayerModal').each(function(index, el) {
      var t = $(this);
      console.log(t[0]);
      t.attr('data-player-id', youtubePlayers.length);

      var player = new YT.Player(t[0], {
        height: '360',
        width: '640',
        videoId: t.attr('data-video-id'),
        playerVars: {
        'modestbranding': 1,
        'autohide': 1,
        'controls': 1,
        'showinfo': 0,
        'rel': 0,
        'autoplay': 0,
        'playsinline': 1
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });
      youtubePlayers.push(player);

      function onPlayerStateChange(event) {
        /*var ytStatus = event.target.getPlayerState();

        // 再生終了したとき
        if (ytStatus == YT.PlayerState.ENDED) {
          player.mute();
          player.playVideo();
        }*/
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {
        //event.target.mute();
        //event.target.playVideo();
      }

      function playVideo() {
        player.mute();
        player.playVideo();
      }

      function stopVideo() {
        player.stopVideo();
      }
    });

    $('.remodalMovie').each(function(index, el) {
      var t = $(this);

      t.on('opening', function () {
      });

      t.on('opened', function () {
        var p = youtubePlayers[t.find('.js-youtubePlayerModal').attr('data-player-id')];
        p.playVideo();
      });

      t.on('closing', function (e) {
        var p = youtubePlayers[t.find('.js-youtubePlayerModal').attr('data-player-id')];
        p.stopVideo();
      });

      t.on('closed', function (e) {
        var p = youtubePlayers[t.find('.js-youtubePlayerModal').attr('data-player-id')];
        p.stopVideo();
      });
    });
  }, 100);
}